/**
 * Centralized WebSocket listener for user-specific events.
 */
export function useUserSync() {
    const { user, getMe } = useAuth()

    const setupListeners = (options: {
        onNotification?: (notification: DbNotification) => void
    } = {}) => {
        if (!user.value?.id) return

        useEcho('users.' + user.value.id)
            .notification(async (notification: DbNotification) => {
                await getMe()

                if (options.onNotification) {
                    options.onNotification(notification)
                }
            })
    }

    return {
        setupListeners,
    }
}
